export default "__VITE_ASSET__g5DBx3NJ__"